module.exports = __webpack_public_path__ + "img/l_Balena.2c6fe3d0.svg";